/* Updated javascript with line fade-in animation (synced with loading bar) */

document.body.style.overflow = 'hidden';

const pageLoading   = document.querySelector('.page-loading');
const el            = document.querySelector('.page-loading-text');
const text          = el ? el.getAttribute('data-text') : '';
const loadingBarEl  = document.querySelector('.loading-bar');
const percentageEl  = document.getElementById('loadingPercentage');

let typingFinished = false;
let pageLoaded     = false;
let forceFadeTimer = null;

// ---- Guards: if markup is missing, unblock immediately
if (!pageLoading || !el || !text) {
  document.body.style.overflow = '';
  if (pageLoading) pageLoading.style.display = 'none';
} else {
  pageLoading.classList.add('show-logo');
  setTimeout(animateLines, 1000);
}

/* ---------- Helpers to sync progress UI ---------- */

// --- replace your current startLoadingBar with this (same name, no change needed) ---
function startLoadingBar(durationMs) {
  if (!loadingBarEl) return;
  document.documentElement.style.setProperty('--loading-duration', `${durationMs}ms`);
  // reset then start
  loadingBarEl.classList.remove('is-animating');
  void loadingBarEl.offsetWidth; // reflow
  loadingBarEl.classList.add('is-animating');
}

// --- replace your startPercentageCounter with this lazy lookup version ---
function startPercentageCounter(durationMs) {
  const el = document.getElementById('loadingPercentage'); // lazy query (ensures it exists)
  if (!el) return;
  el.classList.add('is-visible');

  const start = performance.now();
  function step(now) {
    const elapsed = now - start;
    const pct = Math.min(100, Math.round((elapsed / durationMs) * 100));
    el.textContent = `読み込み中... ${pct}%`;
    if (elapsed < durationMs) requestAnimationFrame(step);
  }
  requestAnimationFrame(step);
}


/* ---------- Text typing animation ---------- */

function animateLines() {
  const lines = text.split('\n');
  el.innerHTML = '';

  let totalDelay = 0;

  lines.forEach((line) => {
    const lineDiv = document.createElement('div');
    lineDiv.classList.add('line-container');

    for (let i = 0; i < line.length; i++) {
      const ch = line.charAt(i);
      const charSpan = document.createElement('span');
      charSpan.textContent = ch === ' ' ? '\u00A0' : ch;
      charSpan.classList.add('char-smoke-fade');
      charSpan.style.animationDelay = `${totalDelay}s`;
      lineDiv.appendChild(charSpan);
      totalDelay += 0.06; // per-char delay
    }

    el.appendChild(lineDiv);
    totalDelay += 0.4; // between-line delay
  });

  // Total time of the full typing effect (+ a small buffer)
  const totalTime = totalDelay * 1000 + 1000;

  // Start/progress UI exactly for the same duration
  startLoadingBar(totalTime);
  startPercentageCounter(totalTime);

  // Mark typing finished at the same time as bar/counter complete
  setTimeout(() => {
    typingFinished = true;
    checkReadyToFade();
  }, totalTime);
}

/* ---------- Fade & readiness logic (with safety) ---------- */

// Mark as loaded if the document is already complete when this runs
if (document.readyState === 'complete') {
  pageLoaded = true;
}

window.addEventListener('load', () => {
  pageLoaded = true;
  checkReadyToFade();
});

function checkReadyToFade() {
  if (!pageLoading) return;

  if (typingFinished && pageLoaded) {
    clearTimeout(forceFadeTimer);
    fadeOut(pageLoading, 800);
    return;
  }

  // Safety: if typing is done but window 'load' lags, force fade shortly
  if (typingFinished && !forceFadeTimer) {
    forceFadeTimer = setTimeout(() => {
      fadeOut(pageLoading, 800);
    }, 1500);
  }
}

function fadeOut(element, duration) {
  element.style.transition = `opacity ${duration}ms ease`;
  element.style.opacity = 1;

  requestAnimationFrame(() => {
    element.style.opacity = 0;
    setTimeout(() => {
      element.style.display = 'none';
      document.body.style.overflow = '';
    }, duration);
  });
}

/* ---------- Site UI scripts ---------- */
document.addEventListener('DOMContentLoaded', function () {
  let lastScrollY = window.scrollY;
  const nav = document.querySelector('.landing-main-nav');
  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;
    if (currentScrollY < lastScrollY) {
      nav && nav.classList.add('show');
    } else {
      nav && nav.classList.remove('show');
    }
    lastScrollY = currentScrollY;
  });

  const openBtn = document.querySelector('.landing-trigger-menu-open');
  const closeBtn = document.querySelector('.landing-trigger-menu-close');
  const mobileNav = document.querySelector('.landing-mobile-nav');
  const mobileNavLinks = document.querySelectorAll('.landing-mobile-nav a');
  openBtn && openBtn.addEventListener('click', () => mobileNav && mobileNav.classList.add('show'));
  closeBtn && closeBtn.addEventListener('click', () => mobileNav && mobileNav.classList.remove('show'));
  mobileNavLinks.forEach((link) => {
    link.addEventListener('click', () => mobileNav && mobileNav.classList.remove('show'));
  });

  const backToTop = document.querySelector('.back-to-top');
  window.addEventListener('scroll', () => {
    if (!backToTop) return;
    if (window.scrollY > 100) backToTop.classList.add('show');
    else backToTop.classList.remove('show');
  });
  backToTop && backToTop.addEventListener('click', () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  });

  document.querySelectorAll('.custom-accoridon-wrap').forEach((accordionWrap) => {
    accordionWrap.addEventListener('click', function (e) {
      const clickedHead = e.target.closest('.custom-accordion-head');
      if (!clickedHead || !accordionWrap.contains(clickedHead)) return;

      const contentId = clickedHead.getAttribute('content-id');
      const targetBody = document.getElementById(contentId);
      if (!targetBody) return;

      const isActive = clickedHead.classList.contains('active');
      if (isActive) {
        clickedHead.classList.remove('active');
        targetBody.classList.remove('show');
      } else {
        accordionWrap.querySelectorAll('.custom-accordion-head').forEach((head) => head.classList.remove('active'));
        accordionWrap.querySelectorAll('.custom-accordion-body').forEach((body) => body.classList.remove('show'));
        clickedHead.classList.add('active');
        targetBody.classList.add('show');
      }
    });
  });

  const filterItems = document.querySelectorAll('.filter-item-area');
  const scrollContainer = document.querySelector('.store-location-results');
  filterItems.forEach((item) => {
    item.addEventListener('click', function () {
      filterItems.forEach((el) => el.classList.remove('selected'));
      this.classList.add('selected');
      const areaId = this.getAttribute('location-area-id');
      const target = document.getElementById('location-area-' + areaId);
      if (target && scrollContainer) {
        const offsetTop = target.offsetTop - scrollContainer.offsetTop;
        scrollContainer.scrollTo({ top: offsetTop, behavior: 'smooth' });
      }
    });
  });

  document.addEventListener('click', function (e) {
    const trigger = e.target.closest('.custom-tab-trigger');
    if (!trigger) return;
    const tabWrap = trigger.closest('.custom-tab-wrap');
    if (!tabWrap) return;
    const allTriggers = tabWrap.querySelectorAll('.custom-tab-trigger');
    allTriggers.forEach((t) => t.classList.remove('active'));
    trigger.classList.add('active');
    const allContents = tabWrap.querySelectorAll('.tab-content');
    allContents.forEach((content) => (content.style.display = 'none'));
    const tabId = trigger.id;
    const targetContent = tabWrap.querySelector(`.tab-content[tab-id="${tabId}"]`);
    if (targetContent) targetContent.style.display = 'block';
  });

  const track = document.querySelector('.custom-simple-track');
  let slides = document.querySelectorAll('.custom-simple-slide');
  const progress = document.getElementById('custom-simple-progress');
  const prevBtn = document.getElementById('custom-simple-prev');
  const nextBtn = document.getElementById('custom-simple-next');

  if (track && slides.length) {
    let current = 1;
    let autoplayInterval = null;
    const autoplayDelay = 8000;

    const firstClone = slides[0].cloneNode(true);
    const lastClone  = slides[slides.length - 1].cloneNode(true);
    firstClone.classList.add('clone');
    lastClone.classList.add('clone');
    track.insertBefore(lastClone, slides[0]);
    track.appendChild(firstClone);
    slides = document.querySelectorAll('.custom-simple-slide');

    function getSlideWidth() {
      const slide = slides[0];
      const style = getComputedStyle(slide);
      const slideWidth = slide.offsetWidth;
      const margin = parseFloat(style.marginLeft) + parseFloat(style.marginRight);
      return slideWidth + margin;
    }

    function updateSlider(animate = true) {
      const slideWidth = getSlideWidth();
      const offset = slideWidth * current - (track.parentElement.offsetWidth - slideWidth) / 2;
      track.style.transition = animate ? 'transform 0.5s ease' : 'none';
      track.style.transform = `translateX(-${offset}px)`;

      if (progress) {
        let visibleIndex = current - 1;
        if (visibleIndex < 0) visibleIndex = slides.length - 3;
        if (visibleIndex >= slides.length - 2) visibleIndex = 0;
        progress.textContent = `＜ ${visibleIndex + 1} / ${slides.length - 2} ＞`;
      }
    }

    function nextSlide() {
      if (current >= slides.length - 1) return;
      current++;
      updateSlider();
      setTimeout(() => {
        if (current === slides.length - 1) {
          current = 1;
          updateSlider(false);
        }
      }, 510);
    }

    function prevSlide() {
      if (current <= 0) return;
      current--;
      updateSlider();
      setTimeout(() => {
        if (current === 0) {
          current = slides.length - 2;
          updateSlider(false);
        }
      }, 510);
    }

    function startAutoplay() {
      autoplayInterval = setInterval(nextSlide, autoplayDelay);
    }
    function resetAutoplay() {
      clearInterval(autoplayInterval);
      startAutoplay();
    }

    prevBtn && prevBtn.addEventListener('click', () => { prevSlide(); resetAutoplay(); });
    nextBtn && nextBtn.addEventListener('click', () => { nextSlide(); resetAutoplay(); });
    window.addEventListener('resize', () => updateSlider(false));

    updateSlider(false);
    startAutoplay();

    const playBtn = document.querySelector('.custom-simple-slider-play');
    const pauseBtn = document.querySelector('.custom-simple-slider-pause');
    let isAutoplaying = true;
    function updatePlayPauseButtons() {
      if (!playBtn || !pauseBtn) return;
      if (isAutoplaying) {
        playBtn.classList.add('disabled');
        pauseBtn.classList.remove('disabled');
      } else {
        playBtn.classList.remove('disabled');
        pauseBtn.classList.add('disabled');
      }
    }
    function pauseAutoplay() {
      clearInterval(autoplayInterval);
      isAutoplaying = false;
      updatePlayPauseButtons();
    }
    function resumeAutoplay() {
      resetAutoplay();
      isAutoplaying = true;
      updatePlayPauseButtons();
    }
    playBtn && playBtn.addEventListener('click', resumeAutoplay);
    pauseBtn && pauseBtn.addEventListener('click', pauseAutoplay);
    updatePlayPauseButtons();
  }

  const videoBlocks = document.querySelectorAll('.step-guide-media');
  videoBlocks.forEach(block => {
    const playBtn = block.querySelector('.media-play-btn');
    const coverWrap = block.querySelector('.media-cover-wrap');
    const iframe = block.querySelector('iframe');
    if (!playBtn || !coverWrap || !iframe) return;
    const baseSrc = iframe.getAttribute('src').split('?')[0];
    const autoplaySrc = baseSrc + '?autoplay=1&mute=0&rel=0&modestbranding=1';
    playBtn.addEventListener('click', function () {
      iframe.setAttribute('src', autoplaySrc);
      coverWrap.style.display = 'none';
    });
  });
});
